export default {
  home: '/', // Tu pewnie redirect poleci na dashboard admin/user, ale poleci merge

  // Auth
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  confirmEmail: '/auth/confirm-email/:token',

  // User
  user: '/user', // Dashboard
  userProjects: '/user/projects',
  userProjectsDetails: '/user/projects/:projectId',
  userProjectsDetailsTask: '/user/projects/:projectId/tasks/:taskId',
  userProjectsDetailsTaskUpload: '/user/projects/:projectId/tasks/:taskId/upload',
  userMyTasks: '/user/my-tasks',
  userBillings: '/user/billings-old',

  userBillingsV2: '/user/billings',
  userBillingsV2Details: '/user/billings/:billingId',

  // Admin
  admin: '/admin', // Dashboard
  adminProjects: '/admin/projects',
  adminProjectsDetails: '/admin/projects/:projectId',
  adminProjectsDetailsUsers: '/admin/projects/:projectId/users',
  adminProjectsEdit: '/admin/projects/:projectId/edit',
  adminProjectsCreate: '/admin/projects/create',

  adminProjectsDetailsTask: '/admin/projects/:projectId/tasks/:taskId',
  adminProjectsEditTask: '/admin/projects/:projectId/tasks/:taskId/edit',
  adminProjectsCreateTasks: '/admin/projects/:projectId/create-tasks',
  adminProjectsImportTasks: '/admin/projects/:projectId/import-tasks',

  adminBillings: '/admin/billings-old',
  adminBillingsUserDetails: '/admin/billings-old/users/:userId/:month/:year',

  adminBillingsV2: '/admin/billings',
  adminBillingsV2Create: '/admin/billings/create',
  adminBillingsV2Details: '/admin/billings/:billingId',

  adminUsers: '/admin/users',
  adminUsersDetails: '/admin/users/:userId',
  adminSettings: '/admin/settings',

  // Common
  profile: '/profile',

  // Others
  noMatch: '*',
  test: '/test',
}
